module.exports = __webpack_public_path__ + "static/airhorn-65456641793465d10c73cff90d177495.mp3";